import { Space } from 'antd';
import React from 'react';
import PageTitle from '../../common/PageTitle';

import { useTranslation } from 'react-i18next';
import { useUserProfileQuery } from '../../../features/auth/authApi';
import CourseList from '../components/courseList';
import { useGetCourseListQuery } from '../../../features/courses/coursesApi';

const CoursesPage = () => {
    const { t } = useTranslation();
    const { data: user } = useUserProfileQuery('userDetails');
    const { data: courses } = useGetCourseListQuery('course-catalog');

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle title={t('courses.header') as String} />
            <CourseList courses={courses} user={user} />
        </Space>
    );
};

export default CoursesPage;
